<div id="spd-spinner" class="d-flex f-1 p-4 container justify-content-center">
  <neb-page-load-indicator
    __neb_ui_lit_component
    [useIsolatedBootstrapStyles]="true"
  ></neb-page-load-indicator>
</div>
